'use client'

import React from 'react'
import type { BlogCardProps } from './types'
import classNames from 'classnames'
import Link from 'next/link'
import RightArrowIcon from '../../../icons/rightArrowIcon'

const BlogCard = ({ image, url, description, date, inSlider }: BlogCardProps) => {
    return (
        <Link
            aria-label="Ga naar blog detail pagina"
            href={url ? url : ''}
            className={classNames('w-full group lg:hover:cursor-pointer rounded-10 flex bg-white h-full flex-col', {
                'md:w-[calc(50%-10px)] lg:w-[calc(33.3333%-13.333px)]': !inSlider,
            })}
        >
            <div
                className={classNames(
                    'relative overflow-hidden rounded-t-10 !rounded-l-none rounded-r-10 md:rounded-[10px]'
                )}
            >
                <div
                    className={classNames(
                        `md:h-[271px] h-[235px] [&>img]:h-full [&>img]:transition-all [&>img]:duration-200 lg:group-hover:[&>img]:scale-[1.2] w-full rounded-tl-10 overflow-hidden md:[&>img]:h-[calc(100%+10px)]`
                    )}
                >
                    {image}
                </div>
            </div>
            <div
                className={classNames(
                    `shadow h-auto p-5 transition-all duration-200 justify-between rounded-[10px] flex flex-col bg-white shrink-0 grow z-10 w-full md:shadow -mt-2.5 min-h-[97px]`
                )}
            >
                <div className={`flex flex-col`}>
                    <span
                        className={classNames('lg:hover:cursor-pointer text-xs leading-tight font-normal text-dark/50')}
                    >
                        {date}
                    </span>
                    <p className="my-2 text-[20px] leading-[26px] font-bold text-dark md:line-clamp-2 md:min-h-[52px]">
                        {description}
                    </p>
                    <span className="font-bold text-[16px] leading-[21px] text-[#005E55] block flex gap-3 items-center ml-auto">
                        Lees verder{' '}
                        <RightArrowIcon
                            className="transition-all duration-200 group-hover:translate-x-[4px]"
                            stroke={'#005E55'}
                            fill={'#005E55'}
                        />
                    </span>
                </div>
            </div>
        </Link>
    )
}

export default BlogCard
